var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      attrs: {
        "data-project": _vm.project,
        "data-news": _vm.about.nca,
        "data-whimn": _vm.about.whimn,
        "data-mobile": _vm.about.mobile,
        "data-desktop": !_vm.about.mobile,
        "data-longform": _vm.about.longform,
        "data-theme": _vm.about.theme,
        "data-testenv": _vm.about.isTestEnv,
        "data-type": "dna-custom-app"
      }
    },
    [
      _c(
        "div",
        { staticClass: "dna-custom-app" },
        [
          _vm.content.showDump
            ? _c("pre", { staticClass: "dump" }, [
                _vm._v(
                  "      " +
                    _vm._s(
                      JSON.stringify(
                        { project: _vm.project, about: _vm.about },
                        "utf-8",
                        2
                      )
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("used-view")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 